import { SnackbarProvider } from 'notistack';
import React from 'react';
import { IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import BlockIcon from '@mui/icons-material/Block';
import { Web3ReactProvider } from '@web3-react/core';

import Router from './routes';
import ThemeConfig from './theme';
import ScrollToTop from './components/ScrollToTop';
import { GlobalAppStateProvider } from './state';
import { getWeb3Library } from './helpers/web3';

const App = () => {
  const notistackRef = React.createRef();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <Web3ReactProvider getLibrary={getWeb3Library}>
      <ThemeConfig>
        <SnackbarProvider
          iconVariant={{
            error: <BlockIcon sx={{ p: 0.3, mr: 1 }} />
          }}
          ref={notistackRef}
          action={(key) => (
            <IconButton onClick={onClickDismiss(key)}>
              <CancelIcon />
            </IconButton>
          )}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <GlobalAppStateProvider>
            <ScrollToTop />
            <Router />
          </GlobalAppStateProvider>
        </SnackbarProvider>
      </ThemeConfig>
    </Web3ReactProvider>
  );
};

export default App;
